export * from './DecorativeText';
